module.exports = __webpack_public_path__ + "static/media/anniversary.3e99e443.jpg";